<div
  class="date-range-picker row d-flex flex-column flex-lg-row align-items-center justify-content-end"
  *ngIf="ngbStartDate && ngbEndDate"
>
  <div class="col-lg-5 col-12">
    <div class="from-date-text fw-bold text-start">
      {{ 'fgbcl.date.range.from.date' | translate : { fgbdefault: 'From date' } }}
    </div>
    <div class="input-group my-2">
      <input
        class="form-control date-field"
        name="startDate"
        [(ngModel)]="ngbStartDate"
        ngbDatepicker
        [minDate]="ngbMinDate"
        [maxDate]="ngbEndDate"
        #startDatePicker="ngbDatepicker"
        (click)="startDatePicker.toggle()"
      />
      <button
        class="btn date-range-picker-icon"
        type="button"
        attr.aria-label="{{ 'date.picker.start.date.screenreader' | translate }}"
        (click)="startDatePicker.toggle()"
      >
        <span class="icon material-icons" aria-hidden="true">today</span>
      </button>
    </div>
  </div>
  <div class="col-lg-2">
    <span class="icon material-icons transaction-arrow ps-4 mt-3 d-lg-block d-none" aria-hidden="true">multiple_stop</span>
  </div>
  <div class="col-lg-5 col-12">
    <div class="to-date-text text-start fw-bold mt-4 mt-lg-0">
      {{ 'fgbcl.date.range.to.date' | translate : { fgbdefault: 'To date' } }}
    </div>
    <div class="input-group my-2">
      <input
        ngbDatepicker
        #endDatePicker="ngbDatepicker"
        class="form-control date-field"
        name="endDate"
        [(ngModel)]="ngbEndDate"
        [maxDate]="today"
        [minDate]="ngbStartDate"
        (click)="endDatePicker.toggle()"
      />

      <button
        class="btn date-range-picker-icon"
        attr.aria-label="{{ 'date.picker.end.date.screenreader' | translate }}"
        type="button"
        (click)="endDatePicker.toggle()"
      >
        <span class="icon material-icons" aria-hidden="true">event</span>
      </button>
    </div>
  </div>
</div>
